import type { CollectedEvent, EventSink } from '../ports/event-sink';

const SEND_TIMEOUT_MS = 10_000;

/**
 * POST {endpoint} `{"events":[…]}` — 배포는 Vercel rewrite, 로컬은 Vite proxy 가 /api 를 API 서버로 넘긴다.
 * token 은 보내는 시점의 로그인 토큰(없으면 null)이다. 실어 보내면 서버가 검증해 그 묶음을 그 사용자의 이벤트로 남긴다 (prd/129 FR-007).
 * 사용자 식별자를 본문에 적지 않는다 — 서버는 본문 값을 믿지 않는다
 */
export function createHttpEventSink(endpoint: string, token: () => string | null = () => null): EventSink {
  return {
    async send(events) {
      const bearer = token();
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}) },
        body: JSON.stringify({ events }),
        keepalive: true,
        signal: AbortSignal.timeout(SEND_TIMEOUT_MS),
      });
      // 400(형식)·422(전부 규칙 위반) — 다시 보내도 같은 답이다. 재시도하지 않게 성공으로 친다
      if (!res.ok && res.status !== 400 && res.status !== 422) throw new Error(`events ${res.status}`);
    },
    beacon(events: readonly CollectedEvent[]) {
      if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return false;
      // text/plain 으로 보내야 CORS 사전 요청이 없다 — 서버는 Content-Type 을 따지지 않고 JSON 으로 읽는다
      // sendBeacon 은 헤더를 실을 수 없다 — 탭을 닫을 때 보낸 묶음은 로그인해 있어도 익명으로 남는다 (prd/129 FR-007)
      return navigator.sendBeacon(endpoint, new Blob([JSON.stringify({ events })], { type: 'text/plain' }));
    },
  };
}
